import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserProfileStore = defineStore("userProfile", () => {

    const permissions = ref<string[]>([]);

    const hasPermission = (name: string) => {
        return permissions.value.includes(name);
    }
    return { permissions, hasPermission };
});